export const TYPES = {
  UPDATE_OUTBOUND_FILTER: 'UPDATE_OUTBOUND_FILTER',
  UPDATE_INBOUND_FILTER: 'UPDATE_INBOUND_FILTER',
  UPDATE_AIRPORT_FILTER: 'UPDATE_AIRPORT_FILTER',
  UPDATE_AIRLINE_FILTER: 'UPDATE_AIRLINE_FILTER',
  UPDATE_BOARD_BASIS_FILTER: 'UPDATE_BOARD_BASIS_FILTER',
  UPDATE_RETURN_DATE_FILTER: 'UPDATE_RETURN_DATE_FILTER',
  DELETE_FILTER: 'DELETE_FILTER',
  DELETE_FILTERS: 'DELETE_FILTERS',
};

export const updateOutboundFilter = value => ({
  type: TYPES.UPDATE_OUTBOUND_FILTER,
  value,
});

export const updateInboundFilter = value => ({
  type: TYPES.UPDATE_INBOUND_FILTER,
  value,
});

export const updateAirportFilter = (value, checked) => ({
  type: TYPES.UPDATE_AIRPORT_FILTER,
  value,
  checked,
});

export const updateAirlineFilter = (value, checked) => ({
  type: TYPES.UPDATE_AIRLINE_FILTER,
  value,
  checked,
});

export const updateBoardBasisFilter = (value, checked) => ({
  type: TYPES.UPDATE_BOARD_BASIS_FILTER,
  value,
  checked,
});

export const updateReturnDateFilter = value => ({
  type: TYPES.UPDATE_RETURN_DATE_FILTER,
  value,
});

export const deleteFilter = field => ({
  type: TYPES.DELETE_FILTER,
  field,
});

export const deleteFilters = () => ({
  type: TYPES.DELETE_FILTERS,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/flightFiltersActions.js
 **/